module.exports = __webpack_public_path__ + "0c9089fea3c24d8a932b0f2698f27b49.png";